import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const SellerServices = {
  getTrxSell,
  getSumSell,
  setAPISeller,
  getSellerAPI,
  getProductSeller,
  addProductSeller,
  deleteProductSeller,
  updateProductSeller,
  updateTrxSeller,
  updateStatusToko,
  getStatustoko,
  apitest,
  setSellerDocument,
  syncharga,
  getListBuyer,
  getProductSpecial,
  addProductSpecial,
  delProductSpecial,
  getProductSellerbyIdProduct,
  getProductSellerbyBrandID
}
function getProductSellerbyBrandID (branndid) {
  return fetch(API_URL + '/api/v1/seller/product/brand/' + branndid, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getProductSellerbyIdProduct (idproduct) {
  return fetch(API_URL + '/api/v1/seller/product/' + idproduct, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function delProductSpecial (postdata) {
  return fetch(API_URL + '/api/v1/seller/productspecial', {
    method: 'DELETE',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function addProductSpecial (postdata) {
  return fetch(API_URL + '/api/v1/seller/productspecial', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getProductSpecial (opt) {
  return fetch(API_URL + '/api/v1/seller/productspecial?cari=', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
function getListBuyer (search) {
  let sc = ''
  if (typeof search !== 'undefined' || search !== null) {
    sc = search
  }
  return fetch(API_URL + '/api/v1/seller/buyer?cari=' + sc, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function syncharga (postdata) {
  return fetch(API_URL + '/api/v1/seller/syncharga', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function setSellerDocument (postdata) {
  return fetch(API_URL + '/api/v1/seller/document', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function apitest (postdata) {
  return fetch(API_URL + '/api/v1/seller/apitest', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getStatustoko () {
  return fetch(API_URL + '/api/v1/seller/tokostatus', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function updateStatusToko (status) {
  return fetch(API_URL + '/api/v1/seller/tokostatus/' + status, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function updateTrxSeller (postdata) {
  return fetch(API_URL + '/api/v1/seller/trx/' + postdata.id, {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function updateProductSeller (postdata) {
  return fetch(API_URL + '/api/v1/seller/product/' + postdata.id, {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function deleteProductSeller (id) {
  return fetch(API_URL + '/api/v1/seller/product/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function addProductSeller (postdata) {
  return fetch(API_URL + '/api/v1/seller/product', {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getProductSeller (opt) {
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('sortprodseller')
    } else {
      localStorage.setItem('sortprodseller', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    } else {
      sorder = 'ASC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10000
  }

  if (!opt.search) {
    opt.search = ''
  }
  if (typeof opt.status === 'undefined' || opt.status === null) {
    opt.status = ''
  }
  const page = opt.page - 1
  const sorting = sort + ',' + sorder

  if (opt.categoryid === undefined || opt.categoryid === null) {
    opt.categoryid = ''
  }
  if (opt.brandid === undefined || opt.brandid === null) {
    opt.brandid = ''
  }
  return fetch(API_URL + '/api/v1/seller/product?search=' + opt.search + '&brandid=' + opt.brandid + '&categoryid=' + opt.categoryid + '&status=' + opt.status + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function setAPISeller (postdata) {
  return fetch(API_URL + '/api/v1/seller/api', {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getSellerAPI (postdata) {
  return fetch(API_URL + '/api/v1/seller/api', {
    method: 'GET',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getSumSell () {
  return fetch(API_URL + '/api/v1/seller/trx/today', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function getTrxSell (opt) {
  var sort = 'id'
  var sorder = 'DESC'
  if (opt.sortBy) {
    console.log(opt.sortBy)
    sort = opt.sortBy[0]
    if (typeof sort === 'undefined') {
      sort = localStorage.getItem('sortbytrxbeli')
    } else {
      localStorage.setItem('sortbytrxbeli', sort)
    }
  }
  if (opt.sortDesc) {
    if (opt.sortDesc[0]) {
      sorder = 'DESC'
    } else {
      sorder = 'ASC'
    }
  }
  if (opt.itemsPerPage < 0) {
    opt.itemsPerPage = 10000
  }

  if (!opt.search) {
    opt.search = ''
  }
  if (typeof opt.statustrx === 'undefined' || opt.statustrx === null) {
    opt.statustrx = ''
  }
  const page = opt.page - 1
  const sorting = sort + ',' + sorder
  if (opt.categoryid === undefined || opt.categoryid === null) {
    opt.categoryid = ''
  }
  if (opt.brandid === undefined || opt.brandid === null) {
    opt.brandid = ''
  }
  return fetch(API_URL + '/api/v1/seller/trx?search=' + opt.search + '&brandid=' + opt.brandid + '&categoryid=' + opt.categoryid + '&statustrx=' + opt.statustrx + '&awal=' + opt.awal + '&akhir=' + opt.akhir + '&page=' + page + '&size=' + opt.itemsPerPage + '&sort=' + sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}
